import { render } from "./AddTransfertMag.vue?vue&type=template&id=5dc05614&scoped=true&ts=true"
import script from "./AddTransfertMag.vue?vue&type=script&lang=ts"
export * from "./AddTransfertMag.vue?vue&type=script&lang=ts"

import "./AddTransfertMag.vue?vue&type=style&index=0&id=5dc05614&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc05614"]])

export default __exports__